import React from 'react'
import BrandName from './BrandName'

export default function Footer() {
    return (
        <div className='w-100 bg-dark text-bright p-4 '>
            <a href='https://www.arbtask.com/' target='_blank' rel='noreferrer' className='text-decoration-none'>
                <BrandName light />
            </a>
            <hr />

            <div className='center '>
                <a href="https://www.arbtask.com/affiliate" target="_blank" rel="noreferrer" className='text-decoration-none small' style={{ color: '#ccc' }}>Earn 30% commission</a>
            </div>
        </div>
    )
}
